import React from 'react';
import { Box, Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StepCustomerType = ({ customerChoice, setCustomerChoice }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ py: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 3, fontWeight: 500 }}>
        {t('varausModal.stepCustomerType.enterText')}
      </Typography>
      <RadioGroup
        value={customerChoice}
        onChange={e => setCustomerChoice(e.target.value)}
      >
        <FormControlLabel
          value="new"
          control={<Radio />}
          label={t('varausModal.stepCustomerType.newCustomer')}
        />
        <FormControlLabel
          value="search"
          control={<Radio />}
          label={t('varausModal.stepCustomerType.search')}
        />
        <FormControlLabel
          value="none"
          control={<Radio />}
          label={t('varausModal.stepCustomerType.noCustomer')}
        />
      </RadioGroup>
    </Box>
  );
};

export default StepCustomerType;
